import {
  Avatar,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import StatusBadge from "../../../../v2/MUI_custom_component/Badge/StatusBadge";
import { EMPLOYEE_TYPES_ENUM } from "../Enum";
import IconReusable from "../../../../components/IconReusable";
import { useState } from "react";
import HumbeeModal from "../../../../v2/MUI_custom_component/Modal/HumbeeModal";
import { deleteEmployeeAction } from "../API/Action";
import { toast } from "react-toastify";
import { PermissionModal } from "./PermissionModal";
import GlassModal from "../../../../v2/MUI_custom_component/Modal/GlassModal";
import { updateStaffAction } from "../API/Action";
import { useSelector } from "react-redux";
import { getNameInitials } from "../API/Utils";
import { toCapitalized } from "../../../../v2/Utils/Capitalize";
import DataLostSvg from "../../../Illustrration/components/DataLostSvg";

export const MemberCardHeader = ({ member, fetchEmployeeDetails }) => {
  const [deleteEmployee, setDeleteEmplyee] = useState(false);
  const [employeeUpdateId, setEmployeeUpdateId] = useState(null);
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const [editEmployee, setEditEmployee] = useState(false);
  const selectedCompany = useSelector(
    (state) => state.EmployeeReducer?.selectedFirm || null,
  );
  const VFC_TOKEN = useSelector((state) => state.loginReducer.vfc_token);

  const deleteStaff = async () => {
    setLoading(true);
    const { error, message } = await deleteEmployeeAction(
      employeeUpdateId,
      selectedCompany?.firm_id,
    );
    setLoading(false);

    if (!error) {
      toast.success(message || "Employee deleted successfully");
      await fetchEmployeeDetails();
    } else {
      toast.error(message || "Failed to delete employee");
    }
  };

  const handleStaffEdit = (e_id) => {
    setEditEmployee(true);
    setEmployeeUpdateId(e_id);
  };

  const handlePermissionSave = async (permissionPayload) => {
    const payload = {
      firm_id: selectedCompany?.firm_id,
      staff_details: {
        id: member.id,
        whatsapp_number: null,
        vfc_token: VFC_TOKEN,
        is_whatsapp_same: false,
        permissions: permissionPayload.permissions,
      },
    };
    const { error, message } = await updateStaffAction(payload);
    if (!error) {
      toast.success(message || "Employee updated successfully");
    } else {
      toast.error(message || "Failed to update employee");
    }
    await fetchEmployeeDetails();
    setEditEmployee(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: { xs: 0.5, md: 2 },
        mb: 1,
      }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Avatar
          alt={member?.name}
          sx={{ width: 40, height: 40, bgcolor: "#F0F0F0" }}>
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 500,
              color: "#666",
              fontFamily: "Roboto, sans-serif",
              textAlign: "center",
            }}>
            {getNameInitials(member?.name)}
          </Typography>
        </Avatar>
        <Typography variant="labelD">{toCapitalized(member.name)}</Typography>
        {/* To check once */}
        <StatusBadge
          label={member.role.label}
          status={member.role.label}
          size={isMobile ? "small" : "medium"}
        />
      </Box>
      {member.role.value === EMPLOYEE_TYPES_ENUM.STAFF && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {member.is_editable && (
            <IconButton
              sx={{ padding: { xs: 0.5, md: 1 } }}
              onClick={() => {
                handleStaffEdit(member.id);
              }}>
              <IconReusable name="Edit" size={20} color="#333" />
            </IconButton>
          )}
          {member.is_deletable && (
            <IconButton
              sx={{ padding: { xs: 0.5, md: 1 } }}
              onClick={() => {
                setDeleteEmplyee(true);
                setEmployeeUpdateId(member.id);
              }}>
              <IconReusable name="Delete" size={20} color="#333" />
            </IconButton>
          )}
        </Box>
      )}
      {member.role.value === EMPLOYEE_TYPES_ENUM.ADMIN &&
        member.is_deletable && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton
              sx={{ padding: { xs: 0.5, md: 1 } }}
              onClick={() => {
                setDeleteEmplyee(true);
                setEmployeeUpdateId(member.id);
              }}>
              <IconReusable name="Delete" size={20} color="#333" />
            </IconButton>
          </Box>
        )}
      {deleteEmployee && (
        <HumbeeModal
          open={deleteEmployee}
          onClose={() => setDeleteEmplyee(false)}
          onConfirm={deleteStaff}
          loading={loading}
          title="Are you sure you want to delete this staff?"
          subtitle="All data would be lost for the selected staff."
          confirmLabel="Yes"
          cancelLabel="No"
          illustration={<DataLostSvg />}
        />
      )}
      {editEmployee && (
        <GlassModal
          open={editEmployee}
          onClose={() => setEditEmployee(false)}
          title="Edit Access"
          scrollable={true}
          maxWidth="600px"
          zIndex={2}>
          <PermissionModal
            initialPermissions={member.permissions}
            onSave={handlePermissionSave}
            onClose={() => setEditEmployee(false)}
          />
        </GlassModal>
      )}
    </Box>
  );
};
